var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.getUser.orgName))]),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"small-print"},[_vm._v(" "+_vm._s(_vm.$t('poweredByFirst'))),_c('br'),_vm._v(_vm._s(_vm.$t('poweredBySecond'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }